/* jshint browserify: true */

import _ from 'lodash';
import widgetFactory from '../widgetFactory';

const widgetName = 'checkEnableInput';

export default widgetFactory(widgetName, {
  _create() {
    this._super(widgetName);
    const $activator = this.getWidgetElement('activator');
    this.inputStateInversed = false;

    if (!_.isEmpty($activator)) {
      this.elements.$activator = $activator;
    } else {
      this.inputStateInversed = true;
      this.elements.$activator = this.getWidgetElement('activatorInversed');
    }

    this.elements.$input = this.getWidgetElement('input');

    this._updateInputTextState();

    this.elements.$activator.on(
      'change',
      function () {
        this._updateInputTextState();
      }.bind(this)
    );
  },

  _updateInputTextState() {
    let inputDisabled;

    if (this.inputStateInversed) {
      inputDisabled = !!this.elements.$activator.prop('checked');
    } else {
      inputDisabled = !this.elements.$activator.prop('checked');
    }

    this.elements.$input.prop('disabled', inputDisabled);
  },
});
